export default "__VITE_ASSET__CW7mFbb9__"